import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
  Col,
  InputGroup,
} from "reactstrap"
import * as Yup from "yup"
import Select from "react-select";
import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import breadcrumbs from "common/Breadcrumbs"
import AttendanceUserTable from "./AttendanceUserTable"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import { GetObjByAttendanceUserRoles } from "_mock/Static_data"

const colourStyles = {
  option: (styles, { isDisabled, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
      color: isFocused ? "#fff" : "#495057",
      cursor: isDisabled ? "not-allowed" : "default",
      padding: "3px 10px",
    }
  },
  control: (styles, { isDisabled }) => {
    const updatedStyles = {
      ...styles,
      border: "1px solid  #ced4da",
      minHeight: "28px",
      padding: "3px 10px",
      fontSize: "12px",
    }
    return updatedStyles
  },
}

const colourStyles1 = {
  option: (styles, { isDisabled, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
      color: isFocused ? "#fff" : "#495057",
      cursor: isDisabled ? "not-allowed" : "default",
      padding: "3px 10px",
    }
  },
  control: (styles, { isDisabled }) => {
    const updatedStyles = {
      ...styles,
      border: "1px solid #f46a6a",
      minHeight: "28px",
      padding: "3px 10px",
      fontSize: "12px",
    }
    return updatedStyles
  },
}

function AttendanceUserList() {
  document.title = `Users | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()

  const navigate = useNavigate()

  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState(null)
  const [tableData, setTableData] = useState([])
  const [attendanceUserId, setAttendanceUserId] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [displayStart, setDisplayStart] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [gender, setGender] = useState("1")
  const [userRoleId, setUserRoleId] = useState(0)
  const [filterRoleId, setfilterRoleId] = useState(0)
  const [isRoleIdRequired, setIsRoleIdRequired] = useState(false)
  const [selectedUser, setSelectedUser] = useState({
    label: "Select",
    value: 0,
  })
  const [userControls, setUserControls] = useState([])
  const [isUserIdRequired, setIsUserIdRequired] = useState(false)
  const [isActive, setIsActive] = useState(false)

  // filter data for user
  const filterData = textFilter => {
    setSearchText(textFilter == undefined ? '' : textFilter)
  }

  const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
    setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    setSearchText(serchValue == undefined ? "" : serchValue)
    setRowsPerPage(pageSize)
  }

  useEffect(() => {
    getApi('User/user-lookup').then(({ data, status }) => {
      if (status === 200) {
        let options = data.map((item) => ({
          label: item.Value,
          value: item.Key,
        }));
        options.unshift({
          label: "Select user",
          value: 0,
        })
        setUserControls(options)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }, [])


  // user list api
  const attendanceUserListApi = () => {
    setIsLoading(true)
    setScreenLoad(true)
    postApi("Attendance/user-list", {
      IsActive: isActive ? false : true,
      RoleId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(filterRoleId) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
      displayStart: displayStart,
      pageSize: rowsPerPage,
      searchText: searchText.trim(),
      sortColumn: "",
      sortOrder: "asc",
    }).then(({ data, status }) => {
      if (status === 200) {
        setTableData(data.AttendanceUserList)
        setTotalRecords(data.TotalRecords)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setIsLoading(false)
      setScreenLoad(false)
    })
  }

  // user list api useEffect
  useEffect(() => {
    attendanceUserListApi()
  }, [rowsPerPage, searchText, displayStart, filterRoleId, isActive])

  // Delete user handler
  const handleDelete = attendanceUserId => {
    setScreenLoad(true)
    if (attendanceUserId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this user permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`Attendance/delete-user?id=${attendanceUserId}`).then(
            async ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== attendanceUserId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("Sucessfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                toast.error(data, {
                  style: {
                    fontSize: "15px",
                  },
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Update user handler
  const handleEditUser = (userData) => {
    setSelectedUser({
      label: "Select",
      value: 0,
    })
    if (userData) {
      setEditData(userData)
      setUserRoleId(userData?.RoleId)
      setGender(String(userData.Gender))
      setAttendanceUserId(userData.Id)
      const matchedUser = userControls.find(u => u.value == userData.UserId);
      if (matchedUser) {
        setSelectedUser(matchedUser);
      }
      setIsEdit(true)
      setModal(!modal)
    }
  }

  // Create user handler
  const handleUserClick = () => {
    setIsEdit(false)
    setSelectedUser({
      label: "Select",
      value: 0,
    })
    setIsRoleIdRequired(false)
    setUserRoleId(0)
    toggle()
  }

  // Colors Validations
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Fullname: isEdit ? editData?.FullName : "",
      ContactNo: isEdit ? editData?.ContactNo : "",
      Password: isEdit ? editData?.Password : "",
      HourlySalary: isEdit ? editData?.HourlySalary : "",
    },
    validationSchema: Yup.object({
      Fullname: Yup.string().required("The full name is required"),
      ContactNo: Yup.string().required("The username is required"),
      HourlySalary: Yup.string().required("The hourly salary is required"),
      Password: (userRoleId != 1) && Yup.string().required("The password is required"),
    }),
    onSubmit: values => {
      if (userRoleId == 0) {
        setIsRoleIdRequired(true)
        return true
      }

      if ((userRoleId == 1 && userRoleId != 0) && parseInt(selectedUser.value) == 0) {
        setIsUserIdRequired(true)
        return true
      }

      setIsUserIdRequired(false)
      setIsRoleIdRequired(false)
      setformSumitLoading(true)
      if (values) {
        postApi("Attendance/create-update-user", {
          id: isEdit ? attendanceUserId : 0,
          UserId: parseInt(selectedUser?.value || 0) || 0,
          Fullname: values.Fullname,
          ContactNo: values.ContactNo,
          Password: values.Password,
          RoleId: parseInt(userRoleId),
          HourlySalary: parseFloat(values.HourlySalary) || 0,
          Gender: parseInt(gender)
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 400) {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            toast.success(isEdit ? "Sucessfully updated" : "Sucessfully updated", {
              style: {
                fontSize: "15px",
              },
            })
            setUserRoleId(0)
            setformSumitLoading(false)
            toggle()
            attendanceUserListApi()
            validation.handleReset()
          }
        })

      }
    },
  })

  // popup box handler
  const toggle = () => {
    setModal(!modal)
    setUserRoleId(0)
    validation.handleReset()
  }

  const handleSwitch = async (id, value) => {
    setScreenLoad(true)
    activeInactiveUserApi(id)
  }

  const activeInactiveUserApi = (id) => {
    DeleteModel.confirmDeleteInquiry({
      title: "Are you sure ?",
      text: "You want to Inactive this user permanently ?",
      isMobile,
    }).then(response => {
      if (response == true) {
        putApi(`Attendance/active-user`,
          {
            id: parseInt(id),
          }).then(({ data, status }) => {
            if (status === 200) {
              toast.success("Sucessfully Changed", {
                style: {
                  fontSize: "15px",
                },
              })
              setScreenLoad(false)
            } else {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
              setScreenLoad(false)
            }
            attendanceUserListApi()
            setScreenLoad(false)
          })
      } else {
        attendanceUserListApi()
        setScreenLoad(false)
      }
    })
  }

  // table headers & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "Id",
        width: "4%"
      },
      {
        Header: "Role",
        accessor: "RoleId",
        width: "12%",
        Cell: ({ row }) => {
          return (
            <div>{GetObjByAttendanceUserRoles(row.original.RoleId)[0]?.Key}</div>
          )
        },
      },
      {
        Header: "Full Name",
        accessor: "FullName",
      },
      {
        Header: "Gender",
        accessor: "Gender",
        width: "6%",
        Cell: ({ row }) => {
          return (
            <div>{row.original.Gender == 1 ? "Male" : "Female"}</div>
          )

        },
      },
      {
        Header: "Contact#",
        accessor: "ContactNo",
        width: "12%"
      },
      {
        Header: "Password",
        accessor: "Password",
        width: "12%",
        Cell: ({ row }) => {
          return (
            <div>{row.original.Password ? row.original.Password : "N/A"}</div>
          )

        },
      },
      {
        Header: "Hourly Salary",
        accessor: "HourlySalary",
        width: "7%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.HourlySalary || 0)}
            </div>
          )
        },
      },
      // {
      //   Header: "Password",
      //   accessor: "Password",
      //   width: "10%"
      // },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Is Active
          </div>
        ),
        width: "6%",
        accessor: "IsActive",
        disableSorting: true,
        Cell: ({ row }) => (
          <FormGroup switch className="d-flex justify-content-center">
            <Input
              id={`IsActive_${row.original.Id}`}
              type="switch"
              defaultChecked={row.original.IsActive}
              onClick={e => {
                handleSwitch(row.original.Id, e.target.checked)
              }}
            />
          </FormGroup>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "7%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditUser(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  className="fs-6 fas fa-trash-alt btn-delete"
                  id={`deletetooltip${row.original.Id}`}
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  const handleKeyPress = event => {
    const charCode = event.which || event.keyCode;
    if (charCode < 45 || charCode > 57) {
      event.preventDefault();
    }
  };

  function writeDataToExcel() {
    setIsLoading(true)
    let header = ["Role", "Full Name", "Gender", "Contact No.", "Hourly Salary",];
    const mainTitle = "Attendance Users";
    const widthObj = [{
      Key: "A",
      Value: 15,
    },
    {
      Key: "B",
      Value: 18,
    },
    {
      Key: "C",
      Value: 12,
    },
    {
      Key: "D",
      Value: 10,
    },
    {
      Key: "E",
      Value: 30,
    },
    ]
    const extention = "Attendance_Users.xlsx"
    let excelSheetData = []

    postApi("Attendance/user-list", {
      RoleId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(filterRoleId) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
      displayStart: displayStart,
      pageSize: 10000,
      searchText: searchText.trim(),
      sortColumn: "",
      sortOrder: "asc",
    }).then(({ data, status }) => {
      if (status === 200) {
        for (let index = 0; index < data?.AttendanceUserList.length; index++) {
          let dataObj = {
            Role: GetObjByAttendanceUserRoles(data?.AttendanceUserList[index].RoleId)[0]?.Key,
            FullName: data?.AttendanceUserList[index].FullName,
            Gender: data?.AttendanceUserList[index].Gender == 1 ? "Male" : "Female",
            ContactNo: data?.AttendanceUserList[index].ContactNo,
            HourlySalary: Number(Math.round(data?.AttendanceUserList[index].HourlySalary).toFixed(2)),
          }
          excelSheetData.push(dataObj)
        }
        var fields = Object.keys(excelSheetData[0]);
        var sheetData = excelSheetData.map(function (row) {
          return fields.map(function (fieldName) {
            return row[fieldName];
          });
        });
        setIsLoading(false)
        sheetData.unshift(header);
        exportDataExcel(sheetData, mainTitle, widthObj, extention)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setIsLoading(false)
      setScreenLoad(false)
    })

    setIsLoading(false)

  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].parent}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
          link={breadcrumbs[pathname].parentLink}
        />
        <Card>
          <CardBody>
            <AttendanceUserTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isAddUserList={true}
              handleUserClick={handleUserClick}
              customPageSize={10}
              className="custom-header-css"
              filterData={filterData}
              isLoading={isLoading}
              TotalRecords={totalRecords}
              pagePerSize={pagePerSize}
              writeDataToExcel={writeDataToExcel}
              filterRoleId={filterRoleId}
              setfilterRoleId={setfilterRoleId}
              setIsActive={setIsActive}
              isActive={isActive}
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "800px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Attendance User" : "Create Attendance User"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={(userRoleId == 1 && userRoleId != 0) ? 6 : 8}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="validationCustom03" className="required">
                            Full Name
                          </Label>
                          <Input
                            name="Fullname"
                            placeholder="Full name"
                            type="text"
                            className="form-control-sm"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.Fullname || ""}
                            invalid={
                              validation.touched.Fullname && validation.errors.Fullname
                                ? true
                                : false
                            }
                          />
                          {validation.touched.Fullname && validation.errors.Fullname ? (
                            <FormFeedback type="invalid">
                              {validation.errors.Fullname}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={(userRoleId == 1 && userRoleId != 0) ? 3 : 4}>
                        <FormGroup>
                          <Label htmlFor="validationCustom03" className="required">
                            Role
                          </Label>
                          <Input
                            type="select"
                            id="validationCustom01"
                            className="form-control"
                            name="taskType"
                            bsSize="sm"
                            onChange={e => {
                              setUserRoleId(e.target.value)
                            }}
                            value={userRoleId}
                            invalid={isRoleIdRequired}
                          >
                            <option value={0}>Select Role</option>
                            {GetObjByAttendanceUserRoles(1, 2, 3, 4).map((item, index) => {
                              return (
                                <option key={index} value={item.Value}>
                                  {item.Key}
                                </option>
                              )
                            })}
                          </Input>
                          {isRoleIdRequired ? (
                            <FormFeedback type="invalid">
                              The role is required
                            </FormFeedback>
                          ) : null}

                        </FormGroup>
                      </Col>
                      {(userRoleId == 1 && userRoleId != 0) &&
                        <Col md={3}>
                          <FormGroup className="mb-2">
                            <Label
                              htmlFor="validationCustom03"
                              className="required"
                            >
                              User
                            </Label>
                            <Select
                              unstyled
                              styles={isUserIdRequired ? colourStyles1 : colourStyles}
                              value={selectedUser}
                              onChange={(e) => {
                                setSelectedUser(e)
                                setIsUserIdRequired(false)
                              }}
                              options={userControls}
                              className="select2-selection"
                            />
                            {isUserIdRequired ? (
                              <div className="name-required">
                                {"User is Required"}
                              </div>
                            ) : null}
                          </FormGroup>
                        </Col>
                      }
                    </Row>
                    <Row>

                      <Col md={4}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="validationCustom03" className="required">
                            Contact No.
                          </Label>
                          <Input
                            name="ContactNo"
                            placeholder="Phone Number"
                            type="text"
                            maxLength="10"
                            onKeyPress={handleKeyPress}
                            className="form-control-sm"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.ContactNo || ""}
                            invalid={
                              validation.touched.ContactNo && validation.errors.ContactNo
                                ? true
                                : false
                            }
                          />
                          {validation.touched.ContactNo && validation.errors.ContactNo ? (
                            <FormFeedback type="invalid">
                              {validation.errors.ContactNo}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      {(userRoleId != 1) &&
                        <Col md={4}>
                          <FormGroup className="mb-2">
                            <Label htmlFor="validationCustom03" className="required">
                              Password
                            </Label>
                            <Input
                              name="Password"
                              placeholder="Password"
                              type="text"
                              className="form-control-sm"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Password || ""}
                              invalid={
                                validation.touched.Password && validation.errors.Password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.Password && validation.errors.Password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.Password}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      }
                      <Col md={4}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="validationCustom03" className="">
                            Hourly Salary
                          </Label>
                          <Input
                            name="HourlySalary"
                            placeholder="0"
                            type="text"
                            // maxLength="10"
                            className="form-control-sm"
                            onKeyPress={handleKeyPress}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.HourlySalary || ""}
                            invalid={
                              validation.touched.HourlySalary && validation.errors.HourlySalary
                                ? true
                                : false
                            }
                          />
                          {validation.touched.HourlySalary && validation.errors.HourlySalary ? (
                            <FormFeedback type="invalid">
                              {validation.errors.HourlySalary}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <div style={{ display: "flex", justifyContent: "end", gap: "20px" }}>

                        <div className="d-flex gap-2 mt-2">
                          <FormGroup>
                            <Input
                              type="radio"
                              value="1"
                              id="male"
                              // name="gender"
                              className="form-check-input"
                              checked={gender === "1"}
                              onClick={() => { setGender("1") }}
                            />
                          </FormGroup>
                          <Label className="form-check-label font-size-13" htmlFor="male">
                            Male
                          </Label>
                          <FormGroup>
                            <Input
                              type="radio"
                              value="2"
                              id="female"
                              // name="gender"
                              className="form-check-input"
                              checked={gender === "2"}
                              onClick={() => { setGender("2") }}
                            />
                          </FormGroup>
                          <Label className="form-check-label font-size-13" htmlFor="female">
                            Female
                          </Label>
                        </div>
                        <div className="mt-1">
                          {isEdit ? (
                            <Button
                              user="secondary"
                              className="btn btn-primary me-2 btn-sm "
                              onClick={handleCancle}
                            >
                              Cancle
                            </Button>
                          ) : (
                            <Button
                              user="secondary"
                              className="btn btn-primary me-2 btn-sm "
                              type="reset"
                            >
                              Reset
                            </Button>
                          )}
                        </div>
                        <div className="mt-1">
                          {formSumitLoading ? (
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              color="secondary"
                            >
                              <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                              Loading
                            </button>
                          ) : (
                            <Button
                              user="primary"
                              className="btn btn-primary btn-sm "
                              type="submit"
                              color="primary"
                            >
                              Submit
                            </Button>
                          )}
                        </div>
                      </div>
                    </Row>
                  </Form>
                </ModalBody>
              </div>
            </Modal>

          </CardBody>
        </Card>
      </div>
    </div>
  )
}
AttendanceUserList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  onFilterChange: PropTypes.func,
}

export default AttendanceUserList
